<template>
  <div>
    <slot></slot>
    <a class="btn btn-primary" @click="DataItem_AddLast"><i class="fas fa-plus-circle"></i></a>
    <div v-if="allowSingleFile">
      僅可新增一個檔案
    </div>
    <table class="table table-hover" id="tblMain">
      <thead class="thead-light">
      <tr>
        <th class="text-center">功能</th>
        <th>檔案</th>
        <th>說明</th>
      </tr>
      </thead>
      <tbody>
      <tr v-for="(item,index) in this.datas" :key="index">
        <td class="text-center">
          <a class="btn btn-danger" @click="DataItem_Remove(item)"><i class="fa fa-trash-alt">  </i></a>
          <a class="btn btn-primary" @click="DataItem_MoveUp(item)"><i class="fa fa-angle-up"></i>  </a>
          <a class="btn btn-primary" @click="DataItem_MoveDown(item)"><i class="fa fa-angle-down"></i>  </a>
        </td>
        <td width="300px">
          <a v-if="item.Url" :href="convertToRealUrl(item.Url)" target="_blank" >下載</a>
          <FileUploadButton :emmit-back-param="item" v-on:uploadSuccess="uploadSuccess" file-type="file" to-storage="true" ></FileUploadButton>
        </td>
        <td >
          <textarea class="form-control" rows="7" v-model="item.Desc"></textarea>
        </td>
      </tr>

      </tbody>
    </table>
  </div>
</template>

<script>
/**
 <ListEditFile query-type="test" :allow-single-file="false"></ListEditFile>

 **/

import arrayUtil from "../../../util/arrayUtil";
import util from "../../../util/util";
import FileUploadButton from "@/views/taylorAdmin/component/FileUploadButton";
import Vue from "vue";
export default {
  components: {FileUploadButton},
  //name: "imageListUpload",
  props: ["datas","allowSingleFile"],
  data: function () {
    return {
      id: "",
      dataReady: false,
      formData: {
        name: "",
      },
      datasDemo:[
        {
          SystemId:"",
          OrderKey:"",
          Url:"https://via.placeholder.com/1920x500",
          Desc:"內文說明活動說明照片說明",
        },
        {
          SystemId:"",
          OrderKey:"",
          Url:"https://via.placeholder.com/1920x501",
          Desc:"內文說明活動說明照片說明",
        },
        {
          SystemId:"",
          OrderKey:"",
          Url:"https://via.placeholder.com/1920x502",
          Desc:"內文說明活動說明照片說明",
        },
        {
          SystemId:"",
          OrderKey:"",
          Url:"https://via.placeholder.com/1920x503",
          Desc:"內文說明活動說明照片說明",
        },
      ]
    };
  },
  methods: {
    convertToRealUrl(url){
      // return Vue.prototype.$apiAdress.replace(/\/$/, "") +url;
      return Vue.prototype.$apiAdress.replace(/\/$/, "")+"/admin/downloadFile?url=" +url;
    },
    DataItem_MoveUp(item){
      arrayUtil.orderMove(false,item.SystemId,this.datas,"SystemId","OrderKey")
    },
    DataItem_MoveDown(item){
      arrayUtil.orderMove(true,item.SystemId,this.datas,"SystemId","OrderKey")
    },
    DataItem_AddLast(){
      if (this.allowSingleFile){
        if (this.datas.length>0){
          alert("僅可新增一個檔案");
          return;
        }
      }

      let newItem=
          {
            SystemId:"",
            OrderKey:"",
            Url:"",
            Desc:"",
          };
      newItem.SystemId =util.uuid();

      arrayUtil.orderAppendLast(newItem,this.datas,"OrderKey")
    },
    DataItem_Remove(item){
      arrayUtil.removeByPredicate(this.datas,s => s.SystemId===item.SystemId);
    },
    uploadSuccess(image,result){
      if (result && result.data.FileCount>0){
        image.Url=result.data.FileUrls[0]
      }else{
        alert("檔案上傳失敗")
      }
    },

  },
  mounted() {
  },
}
</script>

<style scoped>
#tblMain{
  width: 1000px;
}
.btn{
  color: white !important;
  margin: 5px;
  width: 40px;
}
</style>
